//css
import { Link } from "react-router-dom";
import styled from "styled-components";

//img
import HeartIconSvg from "../../assets/img/icon/icon_heart.svg";
import FullHeartIconSvg from "../../assets/img/icon/icon_full_heart.svg";

// responsive
import { M, T } from "../../utils/MT";

export default function LikeButton(props) {
    return (
        <>
            <LikeInput type="checkbox" id={props.id} />
            <LikeLabel htmlFor={props.id}></LikeLabel>
        </>
    );
}

const LikeInput = styled.input`
    display: none;

    &:checked + label {
        background-image: url(${FullHeartIconSvg});
        filter: none;
    }
`;

const LikeLabel = styled.label`
    display: block;
    width: calc(100vw * (17 / 1920));
    height: calc(100vw * (20 / 1920));

    background: url(${HeartIconSvg}) no-repeat center center / contain;
    filter: invert(57%) sepia(90%) saturate(5516%) hue-rotate(5deg) brightness(107%) contrast(102%);

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (17 / 1300));
        height: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(11)};
        height: ${M(11)};
    }
`;
